<script setup>
import {defineProps, defineEmits, ref, onMounted} from "vue";
import {SlideApi} from "@/api/slides";

const props = defineProps({
  svgContent: String,
  icon: Object,
  width: String,
  height: String,
  top: String,
  left: String,
})

let svg = ref("");
let sizes = {
  width: props.width,
  height: props.height,
  top: props.top,
  left: props.left,
}

function unitToPx(unit, addPX = true) {
  return `${(unit / 12700) * 1.333}${addPX ? 'px' : ''}`
}

function getSvg(icon) {
  SlideApi.icons(icon.name).then(response => {
    const icon = response[0];
    if (icon) {
      svg.value = icon.svg
      sizes = {
        width: unitToPx(icon.width),
        height: unitToPx(icon.height),
        top: unitToPx(icon.top),
        left: unitToPx(icon.left),
      }
    }
  })
}

onMounted(() => {
  if (props.svgContent) svg.value = props.svgContent
  // else getSvg(props.icon);
});


</script>

<template>
  <div class="svg" ref="svgContainer"
       :style="{width: sizes.width, height: sizes.height, top: sizes.top, left: sizes.left}" v-if="svg"
       v-html="svg"></div>
</template>

<style scoped>
.svg {
  position: absolute;
}
</style>